import React, { lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";
import { IpPermission } from "./pages/IpPermissions/IpPermission";
import navConfig from "./layouts/dashboard/NavConfig";
import WithdrawActive from "./pages/Wallet/WithdrawActive";
const UpdateUserList = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "update-user" */ "./pages/UpdateUser/UpdateUserList"
    ),
);

const ArbitrageUnrealize = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "arbitrage-unrealize" */ "./pages/ArbitrageSection/ArbitrageUnrealize"
    ),
);

const ArbitrageUnrealizeApply = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "arbitrage-apply" */ "./pages/ArbitrageSection/ArbitrageApply"
    ),
);

const ArbitrageUnrealizeAll = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "arbitrage-release-all" */ "./pages/ArbitrageSection/ReleaseAll"
    ),
);

const WalletEstimate = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "wallet-estimate" */ "./pages/Wallet/WalletEstimate"
    ),
);

const WalletExecute = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "wallet-execute" */ "./pages/Wallet/WalletExecute"
    ),
);

const SignalsList = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "ai-signals" */ "./pages/AiSignals/SignalsList"
    ),
);

const CreatePlan = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "create-signals" */ "./pages/AiSignals/CreateSignals"
    ),
);

const WalletStats = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "wallet-stats" */ "./pages/WalletStats/WalletStats"
    ),
);

const WalletList = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "wallet-list" */ "./pages/WalletStats/WalletList"
    ),
);

const WalletHistory = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "wallet-history" */ "./pages/WalletStats/WalletHistory"
    ),
);

const AiSignalState = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "ai-signal-state" */ "./pages/AiSignals/AiSignalState"
    ),
);

const AISubscriptionsList = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "ai-subscriptions" */ "./pages/AI-Subscriptions/SubscriptionsList"
    ),
);

const EarnPlanStats = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "earn-plan-stats" */ "./pages/EarnStats/EarnStat"
    ),
);

const DaliyReports = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "daily-reports" */ "./pages/Reports/DaliyReports"
    ),
);

const DailyPnl = lazyWithFallback(
  () => import(/* webpackChunkName: "daily-pnl" */ "./pages/Reports/DailyPnl"),
);

const TopTraders = lazyWithFallback(
  () =>
    import(/* webpackChunkName: "top-traders" */ "./pages/Reports/TopTraders"),
);

const TopVolume = lazyWithFallback(
  () =>
    import(/* webpackChunkName: "top-volume" */ "./pages/Reports/TopVolume"),
);

const BypassUser = lazyWithFallback(
  () =>
    import(/* webpackChunkName: "bypass-user" */ "./pages/Bypass/BypassUser"),
);

const AddByPassUser = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "add-bypass-user" */ "./pages/Bypass/AddByPassUser"
    ),
);

const PositionHistory = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "position-history" */ "./pages/SearchUser/PositionHistory"
    ),
);

const UserEarn = lazyWithFallback(
  () =>
    import(/* webpackChunkName: "user-earn" */ "./pages/EarnStats/UserEarn"),
);
const FututreSystemLogs = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "login" */ "./pages/activePage/FututreSystemLogs"
    ),
);
const AddBlogCategory = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "login" */ "./pages/blog-categories/AddCategory"
    ),
);
const EditBlogCategory = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "login" */ "./pages/blog-categories/EditCategory"
    ),
);
const BlogsList = lazyWithFallback(
  () =>
    import(/* webpackChunkName: "login" */ "./pages/blogs-section/BlogsList"),
);
const AddBlog = lazyWithFallback(
  () => import(/* webpackChunkName: "login" */ "./pages/blogs-section/AddBlog"),
);
const EditBlog = lazyWithFallback(
  () =>
    import(/* webpackChunkName: "login" */ "./pages/blogs-section/EditBlog"),
);

function lazyWithFallback(factory) {
  return lazy(() =>
    factory().then((mod) => {
      if (mod && mod.default) {
        return { default: mod.default };
      }
      const keys = mod
        ? Object.keys(mod).filter((key) => key !== "__esModule")
        : [];
      if (keys.length === 1) {
        return { default: mod[keys[0]] };
      }
      const firstNamedExport = keys.reduce((found, key) => {
        if (found) return found;
        return typeof mod[key] === "function" ? mod[key] : found;
      }, null);
      return { default: firstNamedExport || mod };
    }),
  );
}

const Login = lazyWithFallback(
  () => import(/* webpackChunkName: "login" */ "./pages/login/Login"),
);
const BlogCategories = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "login" */ "./pages/blog-categories/BlogCategoriesList"
    ),
);
const ForgotPassword = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "forgot-password" */ "./pages/forgot-password/ForgotPassword"
    ),
);
const Page404 = lazyWithFallback(
  () => import(/* webpackChunkName: "404" */ "./pages/page-404/Page404"),
);
const DashboardLayout = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "dashboard-layout" */ "./layouts/dashboard/DashboardLayout"
    ),
);
const Profile = lazyWithFallback(
  () => import(/* webpackChunkName: "profile" */ "./pages/profile/Profile"),
);
const Dashboard = lazyWithFallback(
  () =>
    import(/* webpackChunkName: "dashboard" */ "./pages/dashboard/Dashboard"),
);
const Users = lazyWithFallback(
  () => import(/* webpackChunkName: "users" */ "./pages/users/Users"),
);
const Deposit = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "deposit" */ "./pages/DepositList/DepositListData"
    ),
);
const KycList = lazyWithFallback(
  () => import(/* webpackChunkName: "kyc" */ "./pages/KycList/KycList"),
);
const TicketList = lazyWithFallback(
  () =>
    import(/* webpackChunkName: "tickets" */ "./pages/TicketList/TicketList"),
);
const CodeListing = lazyWithFallback(
  () => import(/* webpackChunkName: "packages" */ "./pages/Packages/CodeList"),
);
const AddPackage = lazyWithFallback(
  () =>
    import(/* webpackChunkName: "add-package" */ "./pages/Packages/AddPackage"),
);
const AddTask = lazyWithFallback(
  () => import(/* webpackChunkName: "task" */ "./pages/Task/AddTask"),
);
const TaskList = lazyWithFallback(
  () => import(/* webpackChunkName: "task-list" */ "./pages/Task/TaskList"),
);
const UpdateTaskList = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "update-task" */ "./pages/Task/UpdatedTaskList"
    ),
);
const CategoryList = lazyWithFallback(
  () =>
    import(/* webpackChunkName: "category" */ "./pages/Category/CategoryList"),
);
const AddCategory = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "add-category" */ "./pages/Category/AddCategory"
    ),
);
const UpdateCategoryList = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "update-category" */ "./pages/Category/UpdateCategory"
    ),
);
const KycDetails = lazyWithFallback(
  () =>
    import(/* webpackChunkName: "kyc-details" */ "./pages/KycList/KycDetails"),
);
const KycCountryUpdate = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "kyc-details" */ "./pages/KycList/KycCountryUpdate"
    ),
);
const TempraryDelete = lazyWithFallback(
  () =>
    import(/* webpackChunkName: "delete" */ "./pages/Delete/TempraryDelete"),
);
const PermanentDelete = lazyWithFallback(
  () =>
    import(/* webpackChunkName: "delete" */ "./pages/Delete/PermanentDelete"),
);
const AddEvent = lazyWithFallback(
  () => import(/* webpackChunkName: "event" */ "./pages/Event/AddEvent"),
);
const EventList = lazyWithFallback(
  () => import(/* webpackChunkName: "event-list" */ "./pages/Event/EventList"),
);
const SearchUser = lazyWithFallback(
  () => import(/* webpackChunkName: "search" */ "./pages/SearchUser/MainUser"),
);
const TransactionList = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "transaction" */ "./pages/Transaction/TransactionList"
    ),
);
const ActiveUser = lazyWithFallback(
  () => import(/* webpackChunkName: "users" */ "./pages/users/ActiveUser"),
);
const InActiveUser = lazyWithFallback(
  () => import(/* webpackChunkName: "users" */ "./pages/users/InactiveUser"),
);
const BlockUser = lazyWithFallback(
  () => import(/* webpackChunkName: "users" */ "./pages/users/BlockUser"),
);
const WithdrawList = lazyWithFallback(
  () =>
    import(/* webpackChunkName: "withdraw" */ "./pages/Withdraw/WithdrawList"),
);
const CustomerSupport = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "support" */ "./pages/CustomerSupport/CustomerSupport"
    ),
);
const MainApiKey = lazyWithFallback(
  () => import(/* webpackChunkName: "api-key" */ "./pages/ApiKeys/MainApiKey"),
);
const AddApiKey = lazyWithFallback(
  () => import(/* webpackChunkName: "api-key" */ "./pages/ApiKeys/AddApiKey"),
);
const CommissionList = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "commission" */ "./pages/Comission/CommissionList"
    ),
);
const AddBalance = lazyWithFallback(
  () => import(/* webpackChunkName: "balance" */ "./pages/Balance/AddBalance"),
);
const ChangeUser = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "change-user" */ "./pages/ChangeUser/ChangeUser"
    ),
);
const ActiveLog = lazyWithFallback(
  () => import(/* webpackChunkName: "logs" */ "./pages/activePage/ActiveLog"),
);
const AdminActiveLog = lazyWithFallback(
  () =>
    import(/* webpackChunkName: "logs" */ "./pages/activePage/AdminActiveLog"),
);
const SystemActiveLog = lazyWithFallback(
  () =>
    import(/* webpackChunkName: "logs" */ "./pages/activePage/SystemActiveLog"),
);
const Broker = lazyWithFallback(
  () => import(/* webpackChunkName: "broker" */ "./pages/Broker/Broker"),
);
const OpenLevel = lazyWithFallback(
  () => import(/* webpackChunkName: "level" */ "./pages/openLevel/OpenLevel"),
);
const TransferAmount = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "transfer" */ "./pages/TransferAmount/TransferAmount"
    ),
);
const ExbootixHistory = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "history" */ "./pages/ExbotixHistory/ExbotixHistory"
    ),
);
const RoleList = lazyWithFallback(
  () => import(/* webpackChunkName: "role" */ "./pages/Roles/RoleList"),
);
const AddRole = lazyWithFallback(
  () => import(/* webpackChunkName: "role" */ "./pages/Roles/AddRole"),
);
const UpdateRoleList = lazyWithFallback(
  () => import(/* webpackChunkName: "role" */ "./pages/Roles/UpdateRoleList"),
);
const SubAdmin = lazyWithFallback(
  () => import(/* webpackChunkName: "admin" */ "./pages/SubAdmin/SubAdmin"),
);
const AddSubAdmin = lazyWithFallback(
  () => import(/* webpackChunkName: "admin" */ "./pages/SubAdmin/AddSubAdmin"),
);
const SubAdminDetail = lazyWithFallback(
  () =>
    import(/* webpackChunkName: "admin" */ "./pages/SubAdmin/SubAdminDetail"),
);
const AssignPermissions = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "permissions" */ "./pages/Permissions/AssignPermissions"
    ),
);
const Setting = lazyWithFallback(
  () =>
    import(/* webpackChunkName: "settings" */ "./pages/SystemSetting/Setting"),
);
const SpotWallet = lazyWithFallback(
  () =>
    import(/* webpackChunkName: "wallet" */ "./pages/SpotWallet/SpotWallet"),
);
const AdminActiveDetail = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "logs" */ "./pages/activePage/AdminActiveDetail"
    ),
);
const AddSubscription = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "subscription" */ "./pages/Balance/AddSubscription"
    ),
);
const ArbitrageBalance = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "arbitrage" */ "./pages/ArbitrageBalance/ArbitrageBalance"
    ),
);
const ArbitrageHold = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "arbitrage" */ "./pages/ArbitrageHold/ArbitrageHold"
    ),
);
const AddArbitrageHold = lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "arbitrage" */ "./pages/ArbitrageHold/AddArbitrageHold"
    ),
);
const UpdateUser = lazyWithFallback(
  () => import(/* webpackChunkName: "users" */ "./pages/UpdateUser/UpdateUser"),
);

export default function Router() {
  const userData = JSON.parse(localStorage.getItem("user_data"));
  const userPermissions = userData?.roles?.[0]?.permissions || [];

  const permissionNames = Array.isArray(userPermissions)
    ? userPermissions.map((p) => (typeof p === "string" ? p : p?.name))
    : [];

  /**
   * Filter routes recursively based on permissions
   * @param {Array} routes - Navigation configuration
   * @param {Array} permissions - Array of user permission strings
   */
  const filterNavRoutes = (routes, permissions) => {
    return routes.reduce((acc, route) => {
      if (route.children && route.children.length > 0) {
        const filteredChildren = filterNavRoutes(route.children, permissions);
        if (filteredChildren.length > 0) {
          acc.push({
            ...route,
            children: filteredChildren,
          });
        }
      } else {
        const hasAccess = route.id && permissions.includes(route.id);

        if (hasAccess) {
          acc.push(route);
        }
      }

      return acc;
    }, []);
  };

  const filteredNavConfig = filterNavRoutes(navConfig, permissionNames);
  const getFirstMatchedRoute = (routes) => {
    for (const route of routes) {
      if (route.path && !route.children) return route;
      if (route.children) {
        const childMatch = getFirstMatchedRoute(route.children);
        if (childMatch) return childMatch;
      }
    }
    return null;
  };

  const matchedRoute = getFirstMatchedRoute(filteredNavConfig);

  const Authentication = () => {
    const token = localStorage.getItem("token");

    if (token && matchedRoute?.path) {
      return <Navigate to={matchedRoute.path} replace />;
    }

    if (token && !matchedRoute?.path) {
      return <Navigate to="/dashboard" replace />;
    }

    return <Navigate to="/login" replace />;
  };

  return (
    <>
      <Routes>
        <Route path="/" element={<Authentication />} />
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />

        <Route
          element={
            <ProtectedRoute>
              <DashboardLayout routeConfig={navConfig} />
            </ProtectedRoute>
          }
        >
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/users" element={<Users />} />
          <Route path="/change-users" element={<ChangeUser />} />
          <Route path="/wallet-estimate" element={<WalletEstimate />} />
          <Route path="/wallet-execute" element={<WalletExecute />} />
          <Route path="/active-users" element={<ActiveUser />} />
          <Route path="/inactive-users" element={<InActiveUser />} />
          <Route path="/blocked-users" element={<BlockUser />} />
          <Route path="/active-log" element={<ActiveLog />} />
          <Route path="/admin-active-log" element={<AdminActiveLog />} />
          <Route path="/broker-ledger" element={<Broker />} />
          <Route path="/system-active-log" element={<SystemActiveLog />} />
          <Route path="/future-system-log" element={<FututreSystemLogs />} />
          <Route path="/delete/temprary" element={<TempraryDelete />} />
          <Route path="/delete/permanent" element={<PermanentDelete />} />
          <Route path="/customer-support" element={<CustomerSupport />} />
          <Route path="/ip-permission" element={<IpPermission />} />
          <Route path="/unrealize-release" element={<ArbitrageUnrealize />} />
          <Route
            path="/unrealize-apply"
            element={<ArbitrageUnrealizeApply />}
          />
          <Route path="/release-all" element={<ArbitrageUnrealizeAll />} />
          <Route path="/update-user-list" element={<UpdateUserList />} />
          <Route path="/deposit-list" element={<Deposit />} />
          <Route path="/withdraw-list" element={<WithdrawList />} />
          <Route path="/commission-list" element={<CommissionList />} />
          <Route path="/balance/add-balance" element={<AddBalance />} />
          <Route path="/balance/add-balance/:id" element={<AddBalance />} />
          <Route path="/kyc-list/:id" element={<KycList />} />
          <Route path="/kyc-detail" element={<KycDetails />} />
          <Route path="/kyc-country-update" element={<KycCountryUpdate />} />
          <Route path="/ticket-list" element={<TicketList />} />
          <Route path="/package-list" element={<CodeListing />} />
          <Route path="/package-list/add-package" element={<AddPackage />} />
          <Route
            path="/package-list/add-package/:id"
            element={<AddPackage />}
          />
          <Route path="/social/add-social/:id" element={<AddTask />} />
          <Route path="/social/add-social" element={<AddTask />} />
          <Route path="/social" element={<TaskList />} />
          <Route path="/user-subscription" element={<TicketList />} />
          <Route path="/tasks/update-task/:id" element={<UpdateTaskList />} />
          <Route path="/banner-list" element={<CategoryList />} />
          <Route path="/event-list" element={<EventList />} />
          <Route path="/event-list/add-event" element={<AddEvent />} />
          <Route path="/event-list/add-event/:id" element={<AddEvent />} />
          <Route path="/banner/add-banner" element={<AddCategory />} />
          <Route path="/banner/add-banner/:id" element={<AddCategory />} />
          <Route path="/search-user" element={<SearchUser />} />
          <Route path="/open-level" element={<OpenLevel />} />
          <Route path="/transaction-list" element={<TransactionList />} />
          <Route path="/transfer-amount" element={<TransferAmount />} />
          <Route path="/api-key" element={<MainApiKey />} />
          <Route path="/add-api-key" element={<AddApiKey />} />
          <Route path="/exbotix-history" element={<ExbootixHistory />} />
          <Route
            path="/update-user-list/update-user"
            element={<UpdateUser />}
          />
          <Route path="/daily-report" element={<DaliyReports />} />
          <Route path="/daily-pnl" element={<DailyPnl />} />
          <Route path="/top-traders" element={<TopTraders />} />
          <Route path="/top-volume" element={<TopVolume />} />
          <Route path="/bypass-user" element={<BypassUser />} />
          <Route path="/position-history" element={<PositionHistory />} />
          <Route path="/user-earn" element={<UserEarn />} />
          <Route path="/add-bypass" element={<AddByPassUser />} />
          <Route path="/role" element={<RoleList />} />
          <Route path="/role/add-role" element={<AddRole />} />
          <Route path="/role/add-role/:id" element={<AddRole />} />
          <Route path="/update-role" element={<UpdateRoleList />} />
          <Route path="/sub-admin" element={<SubAdmin />} />
          <Route path="/sub-admin/add-admin" element={<AddSubAdmin />} />
          <Route path="/sub-admin/detail-admin" element={<SubAdminDetail />} />
          <Route path="/blog-categories" element={<BlogCategories />} />
          <Route path="/add-blog-category" element={<AddBlogCategory />} />
          <Route
            path="/edit-blog-category/:id"
            element={<EditBlogCategory />}
          />
          <Route path="/blogs-list" element={<BlogsList />} />
          <Route path="/add-blog" element={<AddBlog />} />
          <Route path="/edit-blog/:id" element={<EditBlog />} />
          <Route path="/assign-permission" element={<AssignPermissions />} />
          <Route path="/system-setting" element={<Setting />} />
          <Route path="/spot-wallet" element={<SpotWallet />} />
          <Route path="/add-subscription" element={<AddSubscription />} />
          <Route path="/balance" element={<ArbitrageBalance />} />
          <Route path="/wallet-stats" element={<WalletStats />} />
          <Route path="/wallet-list" element={<WalletList />} />
          <Route path="/wallet-history" element={<WalletHistory />} />
          <Route path="/arbitrage-hold" element={<ArbitrageHold />} />
          <Route path="/arbitrage-hold/add" element={<AddArbitrageHold />} />
          <Route path="/ai-signal" element={<SignalsList />} />
          <Route path="/earn-plan-stats" element={<EarnPlanStats />} />
          <Route path="/ai-signal-stats" element={<AiSignalState />} />
          <Route path="/ai-signal/add-signal" element={<CreatePlan />} />
          <Route path="/ai-signal/add-signal/:id" element={<CreatePlan />} />
          <Route path="/ai-subscriptions" element={<AISubscriptionsList />} />
          <Route path="/withdraw-active" element={<WithdrawActive />} />
          <Route
            path="/admin-active-log/detail"
            element={<AdminActiveDetail />}
          />
          <Route
            path="/banner/update-banner/:id"
            element={<UpdateCategoryList />}
          />
        </Route>

        <Route path="404" element={<Page404 />} />
        <Route path="*" element={<Navigate to="/404" replace />} />
      </Routes>
    </>
  );
}
